import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { InputNumber } from 'hljd'
import style from './style.module.less'

const Item = Form.Item
@Form.create()
@observer
export default class extends Component {
  componentDidMount() {
    const { setFieldsValue } = this.props.form
    const { age_begin, age_end } = this.props.store
    setFieldsValue({ age_begin })
    setFieldsValue({ age_end })
  }
  render() {
    const { age_begin, age_end } = this.props.store
    const { text, required } = this.props.data
    const { getFieldDecorator } = this.props.form

    // 目前只有婚纱摄影-儿童摄影的适用年龄使用该组件，所以写死了age_begin和age_end  历史遗留问题

    return (
      <>
        {required ? <p className={style.label}>{text}</p> : <p>{text}</p>}
        <div className={style.content}>
          <Item>
            {getFieldDecorator('age_begin', {
              initialValue: age_begin,
              rules: [{ required: true, message: `${text}信息未填写` }]
            })(
              <InputNumber
                className={style.area}
                placeholder={text}
                min={0}
                precision={0}
              />
            )}
          </Item>
          <p className={style.line}>——</p>
          <Item>
            {getFieldDecorator('age_end', {
              initialValue: age_end,
              rules: [{ required: true, message: `${text}信息未填写` }]
            })(
              <InputNumber
                className={style.area}
                placeholder={text}
                min={0}
                precision={0}
              />
            )}
          </Item>
        </div>
      </>
    )
  }
}
